import { Flex, HelpIcon, IconButton, RefreshIcon, Text, useTooltip } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'

interface UnavailableValueProps {
  /** what is unavailable, e.g. "APR" */
  label: string
  /** why, shown in the tooltip */
  reason: string
  onRetry?: () => void
  fontSize?: string
}

/**
 * Explicit "unavailable" figure: an em dash with a tooltip and an optional retry.
 * Used where a data source is down, so the UI never shows 0 or NaN for a real value.
 */
const UnavailableValue: React.FC<React.PropsWithChildren<UnavailableValueProps>> = ({
  label,
  reason,
  onRetry,
  fontSize = '16px',
}) => {
  const { t } = useTranslation()
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text bold>{t('%label% unavailable', { label })}</Text>
      <Text small>{reason}</Text>
    </>,
    { placement: 'top' },
  )
  return (
    <Flex alignItems="center" style={{ gap: 4 }}>
      <Flex ref={targetRef} alignItems="center" style={{ gap: 4, cursor: 'help' }}>
        <Text fontSize={fontSize} color="textSubtle" title={`${label}: ${t('unavailable')}`}>
          —
        </Text>
        <HelpIcon width="16px" height="16px" color="textSubtle" />
      </Flex>
      {tooltipVisible && tooltip}
      {onRetry ? (
        <IconButton
          variant="text"
          scale="sm"
          style={{ width: '20px', height: '20px' }}
          aria-label={t('Retry')}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onRetry()
          }}
        >
          <RefreshIcon width="16px" height="16px" color="textSubtle" />
        </IconButton>
      ) : null}
    </Flex>
  )
}

export default UnavailableValue
